import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { SettingsAction } from '../../../types/businesses';
import IOSSwitch from '../../global/IOSSwitch';

export default function Action({
  action,
  disabled,
}: {
  action: SettingsAction;
  disabled?: boolean;
}) {
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end">
      {action.type === 'button' && (
        <LoadingButton
          variant="light"
          loading={action.isLoading}
          disabled={disabled || action.disabled}
          sx={{
            whiteSpace: 'nowrap',
            backgroundColor: '#ffffff',
          }}
          onClick={action.onClick}>
          <span>{action.text}</span>
        </LoadingButton>
      )}
      {action.type === 'switch' && (
        <IOSSwitch
          checked={action.checked}
          onChange={(_, checked) => action.onChange(checked)}
          disabled={action.disabled}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      )}
    </Box>
  );
}
